import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import Select from "react-select";
import "./Ips.css";
import {
  CreateNewIps,
  getMerchantUsers,
  getUser,
} from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const AddNewIp = ({ onClose }) => {
  const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((state) => state.userReducer.role);
  const userId = useSelector((state) => state.userReducer.userId);
  const [ipData, setIpData] = useState({ ip: "" });
  const [merchants, setMerchants] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);

  useEffect(() => {
    const fetchMerchants = async () => {
      try {
        let response;
        let options = [];

        // Always add "Me" option
        const meOption = {
          label: "Me",
          value: userId,
        };

        if (role === "admin") {
          response = await getMerchantUsers(token);

          if (response?.data) {
            options = response.data.map((merchant) => ({
              value: merchant.id,
              label: merchant.name || merchant.id,
            }));
          }
        } else {
          response = await getUser(token);

          if (response?.data) {
            options = response.data.map((user) => ({
              value: user.id,
              label: user.alias || user.id,
            }));
          }
        }
        setMerchants([meOption, ...options]);
        setSelectedMerchant(userId);
      } catch (error) {
        console.error("Error fetching merchants:", error);
        toast.error("Failed to load merchants");
      } finally {
        setLoading(false);
      }
    };

    fetchMerchants();
  }, [token, role, userId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!ipData.ip.trim()) {
      toast.error("Please enter a valid IP and select a merchant.");
      return;
    }

    try {
      setLoading(true);
      await CreateNewIps(
        token,
        ipData.ip,
        selectedMerchant,
        role === "super" ? status : false,
      );
      toast.success("IP added successfully.");
      setSelectedMerchant(null);
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error adding IP:", error);
      toast.error("Failed to add IP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const statusOptions = [
    { value: true, label: "Active" },
    { value: false, label: "Inactive" },
  ];

  return (
    <div className="ips-modal-overlay">
      <div className="ips-modal-content">
        <button onClick={onClose} className="ips-modal-buttons-close">
          <FaTimes size={25} />
        </button>
        <h2>Add New IPs</h2>
        <form onSubmit={handleSubmit}>
          {role !== "admin" && role !== "subAdmin" && (
            <>
              <label htmlFor="merchant">Select Merchant:</label>
              <Select
                options={merchants}
                value={merchants.find((opt) => opt.value === selectedMerchant)}
                onChange={(selectedOption) =>
                  setSelectedMerchant(selectedOption.value)
                }
                isLoading={loading}
              />
            </>
          )}

          <label htmlFor="ip">IP Address:</label>
          <input
            type="text"
            value={ipData.ip}
            onChange={(e) => setIpData({ ip: e.target.value })}
            placeholder="Enter New IP"
          />

          {role === "super" && (
            <>
              <label htmlFor="status">Status:</label>
              <Select
                options={statusOptions}
                value={statusOptions.find((opt) => opt.value === status)}
                onChange={(selectedOption) => setStatus(selectedOption.value)}
              />
            </>
          )}

          <button
            className="ips-modal-buttons"
            type="submit"
            disabled={loading}
          >
            {loading
              ? "Adding..."
              : role === "super"
                ? "Add IPs"
                : "Request IP"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewIp;
